/**
 * Organization: Revzoom India Pvt Ltd.
 * User: om
 * Date: 29/12/16
 * Time: 9:28 PM
 */
// import * as ZoomBridge from '../autogenerated/ZoomBridge';
import Authenticator from './Authenticator';
import HttpOperationPayload from './HttpOperationPayload';
import SerializationUtil from './SerializationUtil';
import ErrorId from './ErrorId';
import $ from 'jquery';
import HttpController from '../controllers/HttpController';
import ErrorHandler from '../error/ErrorHandler';
import Authenticator2 from '../auth/Authenticator2';
import AuthMechanism from '../auth/AuthMechanism';
import AuthType from '../auth/AuthType';
import ConnectionUtil from '../util/session/ConnectionUtil';
import t from '../i18n/I18n';
import System from '../basic/System';

/**
 * AbstractHttpOperation class. Do no create instance of this class directly.
 */
export default class HttpOperation {
  /**
   * @param name{string}
   */
  constructor(name) {
    //Save the name.
    this._name = name;
    /**
     *
     * @type {*}
     * @private
     */
    this._message = null;
    //this._userCanCancel = false;
    /**
     *
     * @type {*}
     * @private
     */
    this._response = null;
    this._authenticator = Authenticator.getInstance();
    //TodoOm: Add request timeout header. Out requests may take long time.
    this._requestId = ++HttpOperation.__REQUESTID;
    this._showProgress = false;
    this._showloader = false;
    this._noAuth = false;
  }

  setAuthenticator(_authenticator) {
    this._authenticator = _authenticator;
  }

  /**
   * Current Request Id
   * @return {number}
   */
  get requestId() {
    return this._requestId;
  }

  /**
   * @return {string}
   */
  get name() {
    return this._name;
  }

  /**
   * @returns {null|*}
   */
  get message() {
    return this._message;
  }

  /**
   *
   * @param message{null|*}
   */
  set message(message) {
    this._message = message;
  }

  //noinspection JSUnusedGlobalSymbols
  set authenticator(authenticator) {
    this._authenticator = authenticator;
  }

  set noAuth(noAuth) {
    this._noAuth = noAuth;
  }

  /**
   * @returns {Promise.<*,ErrorId>}
   */
  run(showProgress = false, showloader = false, getController = ()=>{}) {
    this._showProgress = showProgress;
    this._showloader = showloader;
    if (HttpController.pauseHttpOperations && !Authenticator.isWhitelistedQuery(this)) {
      return new Promise((resolve, reject) => {
        HttpController.enqueue(() =>
          this._send(undefined, getController)
            .then(resolve)
            .catch(reject)
        );
      });
    } else {
      return this._send(undefined, getController);
    }
  }

  /**
   * Do not call this method directly. Always call run method.
   * @returns {Promise}
   * @private
   */
  _send(showProgress = false, getController = ()=>{}) {
    this._lastRequestSentTime = new Date().getTime();
    let data = this._createPayload();
    //  data.showProgress = showProgress;
    return new Promise((onSuccess, onFailure) => {
      let payload = new HttpOperationPayload(data, onSuccess, onFailure);
      this.__previousPayload = payload;
      if (this._authenticator) {
        let canSend = this._authenticator.canSend(this, payload);
        //this._authenticator.modifyRequest(this, payload.data);
        if (canSend) {
          this.__coreSend(payload, getController);
        }
      } else {
        this.__coreSend(payload, getController);
      }
    });
  }

  executePreviousPayload() {
    this.__coreSend(this.__previousPayload);
  }

  /**
   *
   * @param payload{HttpOperationPayload}
   * @private
   */
  __coreSend(payload, getController = ()=>{}) {
    if (this._authenticator) {
      //let canSend = this._authenticator.canSend(this, payload);
      this._authenticator.modifyRequest(this, payload.data);
      // if (canSend) {
      //  this.__coreSend(payload);
      //  }
    }
    let unSecureCall = false;
    const __showProgress = this._showProgress; //payload.data.showProgress !== undefined && payload.data.showProgress;
    const __showloader = this._showloader;

    //Notes: Please read abount in-secure queries in the readme.md. These queries need to be mentioned on the Java and JS side both. - Om
    if (
      payload.data.queryName === 'SendVerificationLinkToUser' ||
      payload.data.queryName === 'CreateUserFromWebClient' ||
      payload.data.queryName === 'GetCollectionParameters' ||
      this._noAuth
    ) {
      unSecureCall = true;
    }
    if (__showProgress || __showloader) {
      window.gs.setProgress(__showProgress, __showloader);
    }

    const controller = $.ajax({
      contentType: HttpOperation.REQUEST_CONTENT_TYPE,
      data: payload.data,
      dataType: 'json',
      method: HttpOperation.POST,
      url: this.url
        ? this.url
        : unSecureCall
        ? ConnectionUtil.getUnSecureURLCall()
        : ConnectionUtil.getSecureURLCall(payload.data.queryName),
      xhrFields: {
        withCredentials: true
      },
      xhr: function() {
        let xhr = new window.XMLHttpRequest();
        xhr.timeout = 60 * 60 * 1000;
        return xhr;
      }
    })
      .done((data, textStatus, jqXHR) => {
        this._ajaxDone(data, textStatus, jqXHR, payload.onSuccess, payload.onFailure);
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        this._ajaxFail(jqXHR, textStatus, errorThrown, payload.onFailure);
      })
      .always(() => {
        if (__showProgress || __showloader) {
          window.gs.setProgress(false, false);
        }
        this._lastRequestDuration = new Date().getTime() - this._lastRequestSentTime;
        if (HttpOperation.debug) {
          console.log('Query: ', this.name, 'Time:', this._lastRequestDuration);
        }
      });
      
      getController(controller);
  }

  /**
   * Creates map of key values pairs which will be send using query params.
   * @returns {*}
   * @private
   */
  _createPayload() {
    let json = this.serializeJson();
    let jsonStringMessage = JSON.stringify(json);
    let data = {};
    data['queryName'] = this.name;
    data['json_operation'] = jsonStringMessage;
    if (this.getAdditionalData) {
      let addlData = this.getAdditionalData();
      if (addlData) {
        for (const key in addlData) {
          data[key] = addlData[key];
        }
      }
    }
    //data['application'] = 'Evolphin Zoom Webclient';
    //data['hostApp'] = navigator.appName;
    //data['debug'] = true;
    return data;
  }

  /**
   *
   * @param data{Object}
   * @param textStatus{string}
   * @param jqXHR
   * @param onSuccess{Function}
   * @param onFailure{Function}
   * @private
   */
  _ajaxDone(data, textStatus, jqXHR, onSuccess, onFailure) {
    const authFailure = this.handleAuthFailure(jqXHR.status, data, textStatus, jqXHR, onFailure);
    if (authFailure) {
      return;
    }
    /**
     * @type {number}
     */
    let status = jqXHR.status;

    let error = false;
    if (status === 200) {
      if (SerializationUtil.isNotSuccess(data)) {
        error = true;
        let errorId = SerializationUtil.createErrorIdIfPresent(data);
        if (HttpOperation.debug) {
          console.log('Error occurred for query: ', this.name, ' Error String: ', errorId.errorDetails);
        }
        if (onFailure) {
          onFailure(errorId);
        }
      }
    }

    if (HttpOperation.debug) {
      console.log('Response received: for query: ', this.name, data, textStatus);
    }
    if (!error) {
      this.deserializeJson(data);
      if (onSuccess) {
        onSuccess(this._response);
      }
    }
  }

  //noinspection JSUnusedLocalSymbols
  /**
   * @param jqXHR
   *
   * @param textStatus{string}
   * @param errorThrown{string}
   * @param onFailure{Function}
   * @private
   */
  _ajaxFail(jqXHR, textStatus, errorThrown, onFailure) {
    let errorResponse = jqXHR == null || !jqXHR.hasOwnProperty('responseJSON') ? errorThrown : jqXHR.responseJSON;
    const authFailure = this.handleAuthFailure(jqXHR.status, errorResponse, textStatus, jqXHR, onFailure);
    if (!authFailure) {
      //      onFailure(jqXHR);
      //  } else {
      let error = ErrorHandler.extractErrorMsg(errorResponse);
      if (!_.isString(error)) {
        error = ErrorHandler.parseErrorCode(jqXHR.status);
        if (!error && jqXHR.status === 0) {
          error = t(System.isDesktop() ? 'CP_NOT_RUNNING' : 'PREVIEW_SERVER_NOT_RUNNING');
        }
      }
      if (error) {
        const errorId = new ErrorId(jqXHR.status, error, 'UNKNOWN');
        // TODO: Use Authenticator.parseError() and code similar to Authenticator.onAuthFailure() to populate backendErrorKey and backendErrorDetails if possible.
        if (onFailure) {
          onFailure(errorId);
        }
      }
    }

    //const authFailure = this.handleAuthFailure(jqXHR.status, errorThrown, textStatus, jqXHR, onFailure);
    //if (!authFailure) {
    //  onFailure(new ErrorId(-1, "Network Connection Error."));
    //} else {
    //onFailure(new ErrorId(Authenticator.ABORT_AUTHZ_ERROR, "Auth Error"));
    //}
  }

  /**
   *
   * @param status{number}
   * @param data{*}
   * @param textStatus{string}
   * @param jqXHR{*}
   * @param onFailure{Function}
   * @return {boolean}
   * @private
   */
  handleAuthFailure(status, data, textStatus, jqXHR, onFailure) {
    let authFailure = false;
    if (this._authenticator) {
      Authenticator2.setAuthTypes(jqXHR);
      authFailure = this.isAuthFailure(status, data, textStatus, jqXHR);
      if (authFailure) {
        /**
         * @type {ErrorId}
         */
        let errorId = this._authenticator.onAuthFailure(this, status, data, jqXHR);

        if (Authenticator.isLoginQuery(this)) {
          onFailure(errorId);
        }
      }
    }
    return authFailure;
  }

  //noinspection JSUnusedLocalSymbols
  /**
   * @param status
   * @param data
   * @param textStatus
   * @param jqXHR
   * @private
   * @return {boolean}
   */
  isAuthFailure(status, data, textStatus, jqXHR) {
    if (this.ignoreAuthFailure) {
      return false;
    }
    return HttpOperation.checkForAuthFailure(status, data);
  }

  /**
   *
   * @param {number} status
   * @param {*} data
   * @returns Returns true if auth failure conditions are met.
   */
  static checkForAuthFailure(status, data) {
    if (status === 200) {
      if (data) {
        if (data.hasOwnProperty('authSuccess')) {
          let authSuccess = data['authSuccess'];
          if (!authSuccess) {
            return true;
          }
        } else if (data.hasOwnProperty('authRequest')) {
          if (data['authRequest'] === true && data['success'] === false) {
            return true;
          }
        }
      }
    } else if (status >= 400 && status < 408 && status !== 405) {
      return true;
    }
    return false;
  }

  /**
   * @private
   */

  /**
   * json{Object}
   */
  serializeJson() {
    throw new Error("Method can't be called.");
  }

  /**
   * @param json
   */
  deserializeJson(json) {
    throw new Error("Method can't be called.");
  }
}
/**
 * @type {string}
 * @const
 */
HttpOperation.POST = 'POST';
/**
 *
 * @type {string}
 * @const
 */
HttpOperation.REQUEST_CONTENT_TYPE = 'application/x-www-form-urlencoded; charset=UTF-8';
/**
 *
 * @type {boolean}
 * @const
 */
HttpOperation.debug = false;
HttpOperation.__REQUESTID = 0;
